import script from "./OperationDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperationDescription.vue?vue&type=script&lang=ts&setup=true"

import "./OperationDescription.vue?vue&type=style&index=0&id=dd5372b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd5372b2"]])

export default __exports__